import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const ChevronLeftIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Chevron Left`} {...props}>
    <Path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m10.5 13-5-5 5-5"
      fill="none"
    />
  </Icon>
);
